import axios from '../../../utils/customAxiosUtil';

import qs from 'qs';
import { AnalysisHistoryState } from '../models/analysisHitoryModel';
// import { ReponseControlGpHistory } from '../models/controlGpModel';

export const analysisHistory = {
  list: async (data: string, page: number) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });

    return await axios.get(`/api/anls/hstry/list${queryString}&page=${page}`);
  },
  detail: async (id: string) => {
    return await axios.get(`/api/anls/hstry/detail/${id}`);
  },

  log: async (id: string) => {
    return await axios.get(`/api/anls/hstry/log/${id}`);
  }
  // getHistory: async (id: string) => {
  //   if (!id) {

  //     return null;
  //   }
  //   const { data }: ReponseControlGpHistory = await axios.get(
  //     `api/ctr/cntrl/history/${id}`
  //   );
  //   return data;
  // }
};
